import { render, staticRenderFns } from "./modules4.vue?vue&type=template&id=7d44a5f3&scoped=true"
import script from "./modules4.vue?vue&type=script&lang=js"
export * from "./modules4.vue?vue&type=script&lang=js"
import style0 from "./modules4.vue?vue&type=style&index=0&id=7d44a5f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d44a5f3",
  null
  
)

export default component.exports